import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

export default function PageLayout({ children, mobile: isMobile }) {
  return <>{!isMobile && <Header>{children}<Divider /></Header>}</>;
}

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  mobile: PropTypes.bool,
};

// ##########################################
// ### Child Components
// ##########################################

export const Header = styled((props) => (
  <Typography variant="h5" {...props} />
))(({ theme }) => ({
  color: theme.palette.text.primary,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(4),
}));
